import { useBreakpoints } from "@/Composables/useBreakpoints";
export default {
    install: () => {
        const { installEventListener } = useBreakpoints();
        installEventListener();
    },
};
